import { createSlice } from '@reduxjs/toolkit';
import { extraReducers } from './async-thunks';
import { INITIAL_STATE, SLICE_NAMESPACE } from './constants';
import { reducers } from './reducers';

const maintenanceSlice = createSlice({
  name: SLICE_NAMESPACE,
  initialState: INITIAL_STATE,
  reducers,
  extraReducers,
});

export const { resetMaintenanceForm, resetMaintenanceModal } = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
